export const GET_ERRORS = 'GET_ERRORS';
export const USER_LOADING = 'USER_LOADING';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const PLAYER_INFORMATION = 'PLAYER_INFORMATION';
export const SET_GLOBALS = 'SET_GLOBALS';

export const SET_GROUP_DATA = 'SET_GROUP_DATA';
